define("shared/utils/formatters/ig-user-from-basic-display", ["exports", "later/models/ig-user"], function (_exports, _igUser) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/models/ig-user"eaimeta@70e063a35619d71f
  const createIgUserFromBasicDisplay = (_ref, socialProfile) => {
    let {
      id,
      username,
      account_type: accountType,
      media_count: mediaCount
    } = _ref;
    return new _igUser.default({
      id,
      username,
      accountType,
      mediaCount,
      socialProfile
    });
  };
  var _default = _exports.default = createIgUserFromBasicDisplay;
});